export default "__VITE_ASSET__DYT5sDc8__"